import { put, call, takeLatest, type CallEffect, type PutEffect, type ForkEffect } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import { EmailConfigActionTypes } from './enums';
import {
	autocompleteUserEmail,
	fetchAllEmailCCConfigs,
	getEmailCCConfigByName,
	upsertEmailCCConfig
} from './api';

type EmailConfigSagaEffect = Generator<CallEffect<any> | PutEffect<any>>;
type EmailConfigSagaFormEffect = Generator<ForkEffect<void>>;

export function* fetchAllEmailCCConfigsEffect(action: AnyAction): EmailConfigSagaEffect {
	const { successCB, errorCB } = action.payload || {};
	try {
		const { data }: any = yield call(fetchAllEmailCCConfigs);
		yield put({ type: EmailConfigActionTypes.FETCH_ALL_EMAIL_CC_CONFIG_SUCCESS, payload: data });
		if (successCB) successCB(data);
	} catch (error: any) {
		const message = error?.message ?? 'Failed to fetch email configs.';
		yield put({ type: EmailConfigActionTypes.FETCH_ALL_EMAIL_CC_CONFIG_FAILURE, payload: message });
		if (errorCB) errorCB(message);
	}
}

export function* getEmailCCConfigByNameEffect(action: AnyAction): EmailConfigSagaEffect {
	const { name, successCB, errorCB } = action.payload;
	try {
		const { data }: any = yield call(getEmailCCConfigByName, name);
		yield put({ type: EmailConfigActionTypes.GET_EMAIL_CC_CONFIG_BY_NAME_SUCCESS, payload: data });
		if (successCB) successCB(data);
	} catch (error: any) {
		const message = error?.message ?? 'Failed to fetch email config.';
		yield put({ type: EmailConfigActionTypes.GET_EMAIL_CC_CONFIG_BY_NAME_FAILURE, payload: message });
		if (errorCB) errorCB(message);
	}
}

export function* upsertEmailCCConfigEffect(action: AnyAction): EmailConfigSagaEffect {
	const { name, formData, successCB, errorCB, finalCB } = action.payload;
	try {
		const { data }: any = yield call(upsertEmailCCConfig, name, formData);
		yield put({ type: EmailConfigActionTypes.UPSERT_EMAIL_CC_CONFIG_SUCCESS, payload: data });
		if (successCB) successCB(data);
	} catch (error: any) {
		const message = error?.message ?? 'Failed to update email config.';
		yield put({ type: EmailConfigActionTypes.UPSERT_EMAIL_CC_CONFIG_FAILURE, payload: message });
		if (errorCB) errorCB(message);
	} finally {
		if (finalCB) finalCB();
	}
}

export function* fetchEmailAutocompleteEffect(action: AnyAction): EmailConfigSagaEffect {
	const { prefix, successCB, errorCB } = action.payload;
	try {
		const { data }: any = yield call(autocompleteUserEmail, prefix);
		yield put({ type: EmailConfigActionTypes.FETCH_EMAIL_AUTOCOMPLETE_SUCCESS, payload: data });
		if (successCB) successCB(data);
	} catch (error: any) {
		const message = error?.message ?? 'Failed to fetch email suggestions.';
		yield put({ type: EmailConfigActionTypes.FETCH_EMAIL_AUTOCOMPLETE_FAILURE, payload: message });
		if (errorCB) errorCB(message);
	}
}

export function* fetchAllEmailCCConfigsSaga(): EmailConfigSagaFormEffect {
	yield takeLatest(EmailConfigActionTypes.FETCH_ALL_EMAIL_CC_CONFIG_REQUEST, fetchAllEmailCCConfigsEffect);
}

export function* getEmailCCConfigByNameSaga(): EmailConfigSagaFormEffect {
	yield takeLatest(EmailConfigActionTypes.GET_EMAIL_CC_CONFIG_BY_NAME_REQUEST, getEmailCCConfigByNameEffect);
}

export function* upsertEmailCCConfigSaga(): EmailConfigSagaFormEffect {
	yield takeLatest(EmailConfigActionTypes.UPSERT_EMAIL_CC_CONFIG_REQUEST, upsertEmailCCConfigEffect);
}

export function* fetchEmailAutocompleteSaga(): EmailConfigSagaFormEffect {
	yield takeLatest(EmailConfigActionTypes.FETCH_EMAIL_AUTOCOMPLETE_REQUEST, fetchEmailAutocompleteEffect);
}
